import { render, staticRenderFns } from "./PrintTemplateLandscape.vue?vue&type=template&id=9ad135c2&"
import script from "./PrintTemplateLandscape.vue?vue&type=script&lang=js&"
export * from "./PrintTemplateLandscape.vue?vue&type=script&lang=js&"
import style0 from "./PrintTemplateLandscape.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports